module.exports = __webpack_public_path__ + "img/visa.c8f40176.svg";